"use strict";
/**
*
* Author: CALIB http://aka.ms/CALIB
* Copyright: Microsoft 2017
*
* ECS Module
*/
Object.defineProperty(exports, "__esModule", { value: true });
var AllowBackgroundFetchData_1 = require("./AllowBackgroundFetchData");
var AppActiveData_1 = require("./AppActiveData");
var Cache_1 = require("./Cache");
var Config_1 = require("./Config");
var Models = require("./Models");
exports.Models = Models;
var Scheduler_1 = require("./Scheduler");
var SkypeTokenData_1 = require("./SkypeTokenData");
var TelemetryManager_1 = require("./TelemetryManager");
var EcsClient = /** @class */ (function () {
    function EcsClient() {
        this._allowBackgroundFetchData = new AllowBackgroundFetchData_1.default();
        this._appActiveData = new AppActiveData_1.default();
        this._config = new Config_1.default();
        this._cache = new Cache_1.default(this._config);
        this._skypeTokenData = new SkypeTokenData_1.default();
        this._telemetryManager = new TelemetryManager_1.default(this._cache);
        this._scheduler = new Scheduler_1.default(this._config, this._skypeTokenData, this._cache, this._appActiveData, this._allowBackgroundFetchData, this._telemetryManager);
        // Typescript 3.X has started inlining type requires for inferred type-only imports if the import isn't used elsewhere in the file
        // Older versions of typescript do not support this so specify it here for backwards definition file compatibility
        this.telemetryEventAdded = this._telemetryManager.telemetryEventAdded;
        this.configUpdated = this._cache.configUpdated;
    }
    EcsClient.prototype.initialize = function (config) {
        var _this = this;
        this._config.initialize(config);
        this._skypeTokenData.putSkypeTokenData(config.initialSkypeTokenData);
        this._appActiveData.putAppActive(config.initialAppActiveState);
        return this._cache.initialize().then(function () {
            _this._scheduler.initialize();
        });
    };
    EcsClient.prototype.getConfig = function () {
        return this._cache.getEcsConfig();
    };
    EcsClient.prototype.getConfigType = function () {
        var cacheConfig = this._cache.getEcsConfig();
        if (!cacheConfig) {
            return undefined;
        }
        return cacheConfig.configType;
    };
    EcsClient.prototype.requestUpdate = function () {
        this._scheduler.requestUpdate();
    };
    EcsClient.prototype.pause = function () {
        this._scheduler.pause();
    };
    EcsClient.prototype.resume = function () {
        this._scheduler.resume();
    };
    EcsClient.prototype.setAllowBackgroundFetch = function (allowBackgroundFetch) {
        this._allowBackgroundFetchData.putBackgroundFetchAllowed(allowBackgroundFetch);
    };
    EcsClient.prototype.useSkypeToken = function (skypeToken, skypeTokenExpiration) {
        this._skypeTokenData.putSkypeTokenData({ skypeToken: skypeToken, skypeTokenExpiration: skypeTokenExpiration });
    };
    EcsClient.prototype.setAppActive = function (active) {
        this._appActiveData.putAppActive(active);
    };
    EcsClient.prototype.setConfigsToFetch = function (types) {
        var _this = this;
        this._config.setConfigsToFetch(types);
        return this._cache.updateConfigsToFetch().then(function () {
            _this._scheduler.updateConfigsToFetch();
        });
    };
    EcsClient.prototype.setFetchTimeout = function (fetchTimeout) {
        this._config.setFetchTimeout(fetchTimeout);
    };
    return EcsClient;
}());
exports.default = EcsClient;
